


var config = require('../config/config.js')
 config =config.env[config.scheme];
// var xecond= config.env[config.scheme].senCond
(function (para) {
    //神策
    var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script', x = null, y = null;
    w['sensorsDataAnalytic201505'] = n;
    w[n] = w[n] || function (a) {
      return function () {
        (w[n]._q = w[n]._q || []).push([a, arguments]);
      }
    };
    var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'clearAllRegister', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister'];
    for (var i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
    if (!w[n]._t) {
      x = d.createElement(s), y = d.getElementsByTagName(s)[0];
      x.async = 1;
      x.src = p;
      w[n].para = para;
      y.parentNode.insertBefore(x, y);
    }
  })({
    sdk_url: config.senCondjs,
    name: 'sensors',
    server_url: config.senCond,
    // server_url:' http://shence.lvyuetravel.com:8107',
    cross_subdomain: true,
    heatmap: {
      //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      clickmap: 'default',
      //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      scroll_notice_map: 'not_collect'
    }
  });
  sensors.registerPage({platformType: 'pc'});
  sensors.quick('autoTrack'); //神策系统必须是1.4最新版及以上


/** WEBPACK FOOTER **
 ** ./src/js/sensorsdata.js
 **/